export const places = [
{ value: "אבו ג'ווייעד שבט", label: "אבו ג'ווייעד שבט" },
{ value: "אבו גוש", label: "אבו גוש" },
{ value: "אבו סנאן", label: "אבו סנאן" },
{ value: "אבו סריחאן שבט", label: "אבו סריחאן שבט" },
{ value: "אבו עבדון שבט", label: "אבו עבדון שבט" },
{ value: "אבו עמאר שבט", label: "אבו עמאר שבט" },
{ value: "אבו עמרה שבט", label: "אבו עמרה שבט" },
{ value: "אבו קורינאת שבט", label: "אבו קורינאת שבט" },
{ value: "אבו קרינאת יישוב", label: "אבו קרינאת יישוב" },
{ value: "אבו רובייעה שבט", label: "אבו רובייעה שבט" },
{ value: "אבו רוקייק שבט", label: "אבו רוקייק שבט" },
{ value: "אבו תלול", label: "אבו תלול" },
{ value: "אבטין", label: "אבטין" },
{ value: "אבטליון", label: "אבטליון" },
{ value: "אביאל", label: "אביאל" },
{ value: "אביבים", label: "אביבים" },
{ value: "אביגדור", label: "אביגדור" },
{ value: "אביגיל", label: "אביגיל" },
{ value: "אביחיל", label: "אביחיל" },
{ value: "אביטל", label: "אביטל" },
{ value: "אביעזר", label: "אביעזר" },
{ value: "אבירים", label: "אבירים" },
{ value: "אבן יהודה", label: "אבן יהודה" },
{ value: "אבן מנחם", label: "אבן מנחם" },
{ value: "אבן ספיר", label: "אבן ספיר" },
{ value: "אבן שמואל", label: "אבן שמואל" },
{ value: "אבני איתן", label: "אבני איתן" },
{ value: "אבני חפץ", label: "אבני חפץ" },
{ value: "אבנת", label: "אבנת" },
{ value: "אבשלום", label: "אבשלום" },
{ value: "אדורה", label: "אדורה" },
{ value: "אדירים", label: "אדירים" },
{ value: "אדמית", label: "אדמית" },
{ value: "אדרת", label: "אדרת" },
{ value: "אודים", label: "אודים" },
{ value: "אודם", label: "אודם" },
{ value: "אוהד", label: "אוהד" },
{ value: "אום אל-פחם", label: "אום אל-פחם" },
{ value: "אום אל-קוטוף", label: "אום אל-קוטוף" },
{ value: "אום בטין", label: "אום בטין" },
{ value: "אומן", label: "אומן" },
{ value: "אומץ", label: "אומץ" },
{ value: "אופקים", label: "אופקים" },
{ value: "אור הגנוז", label: "אור הגנוז" },
{ value: "אור הנר", label: "אור הנר" },
{ value: "אור יהודה", label: "אור יהודה" },
{ value: "אור עקיבא", label: "אור עקיבא" },
{ value: "אורה", label: "אורה" },
{ value: "אורות", label: "אורות" },
{ value: "אורטל", label: "אורטל" },
{ value: "אורים", label: "אורים" },
{ value: "אורנים", label: "אורנים" },
{ value: "אורנית", label: "אורנית" },
{ value: "אושה", label: "אושה" },
{ value: "אזור", label: "אזור" },
{ value: "אחווה", label: "אחווה" },
{ value: "אחוזם", label: "אחוזם" },
{ value: "אחוזת ברק", label: "אחוזת ברק" },
{ value: "אחיהוד", label: "אחיהוד" },
{ value: "אחיטוב", label: "אחיטוב" },
{ value: "אחיסמך", label: "אחיסמך" },
{ value: "אחיעזר", label: "אחיעזר" },
{ value: "אטרש שבט", label: "אטרש שבט" },
{ value: "איבים", label: "איבים" },
{ value: "אייל", label: "אייל" },
{ value: "איילת השחר", label: "איילת השחר" },
{ value: "אילון", label: "אילון" },
{ value: "אילות", label: "אילות" },
{ value: "אילניה", label: "אילניה" },
{ value: "אילת", label: "אילת" },
{ value: "אירוס", label: "אירוס" },
{ value: "איתמר", label: "איתמר" },
{ value: "איתן", label: "איתן" },
{ value: "איתנים", label: "איתנים" },
{ value: "אכסאל", label: "אכסאל" },
{ value: "אל סייד", label: "אל סייד" },
{ value: "אלומה", label: "אלומה" },
{ value: "אלומות", label: "אלומות" },
{ value: "אלון הגליל", label: "אלון הגליל" },
{ value: "אלון מורה", label: "אלון מורה" },
{ value: "אלון שבות", label: "אלון שבות" },
{ value: "אלוני אבא", label: "אלוני אבא" },
{ value: "אלוני הבשן", label: "אלוני הבשן" },
{ value: "אלוני יצחק", label: "אלוני יצחק" },
{ value: "אלונים", label: "אלונים" },
{ value: "אליאב", label: "אליאב" },
{ value: "אליכין", label: "אליכין" },
{ value: "אלי-עד", label: "אלי-עד" },
{ value: "אליפז", label: "אליפז" },
{ value: "אליפלט", label: "אליפלט" },
{ value: "אליקים", label: "אליקים" },
{ value: "אלישיב", label: "אלישיב" },
{ value: "אלישמע", label: "אלישמע" },
{ value: "אלמגור", label: "אלמגור" },
{ value: "אלמוג", label: "אלמוג" },
{ value: "אלעד", label: "אלעד" },
{ value: "אל-עזי", label: "אל-עזי" },
{ value: "אלעזר", label: "אלעזר" },
{ value: "אל-עריאן", label: "אל-עריאן" },
{ value: "אלפי מנשה", label: "אלפי מנשה" },
{ value: "אלקוש", label: "אלקוש" },
{ value: "אלקנה", label: "אלקנה" },
{ value: "אל-רום", label: "אל-רום" },
{ value: "אמונים", label: "אמונים" },
{ value: "אמירים", label: "אמירים" },
{ value: "אמנון", label: "אמנון" },
{ value: "אמציה", label: "אמציה" },
{ value: "אניעם", label: "אניעם" },
{ value: "אסד שבט", label: "אסד שבט" },
{ value: "אספר", label: "אספר" },
{ value: "אעבלין", label: "אעבלין" },
{ value: "אעצם שבט", label: "אעצם שבט" },
{ value: "אפיניש שבט", label: "אפיניש שבט" },
{ value: "אפיק", label: "אפיק" },
{ value: "אפיקים", label: "אפיקים" },
{ value: "אפק", label: "אפק" },
{ value: "אפרת", label: "אפרת" },
{ value: "ארבל", label: "ארבל" },
{ value: "ארגמן", label: "ארגמן" },
{ value: "ארז", label: "ארז" },
{ value: "אריאל", label: "אריאל" },
{ value: "ארסוף", label: "ארסוף" },
{ value: "אשבול", label: "אשבול" },
{ value: "אשבל", label: "אשבל" },
{ value: "אשדוד", label: "אשדוד" },
{ value: "אשדות יעקב איחוד", label: "אשדות יעקב איחוד" },
{ value: "אשדות יעקב מאוחד", label: "אשדות יעקב מאוחד" },
{ value: "אשחר", label: "אשחר" },
{ value: "אשכולות", label: "אשכולות" },
{ value: "אשל הנשיא", label: "אשל הנשיא" },
{ value: "אשלים", label: "אשלים" },
{ value: "אשקלון", label: "אשקלון" },
{ value: "אשרת", label: "אשרת" },
{ value: "אשתאול", label: "אשתאול" },
{ value: "אתגר", label: "אתגר" },
{ value: "באקה אל-גרביה", label: "באקה אל-גרביה" },
{ value: "באר אורה", label: "באר אורה" },
{ value: "באר גנים", label: "באר גנים" },
{ value: "באר טוביה", label: "באר טוביה" },
{ value: "באר יעקב", label: "באר יעקב" },
{ value: "באר מילכה", label: "באר מילכה" },
{ value: "באר שבע", label: "באר שבע" },
{ value: "בארות יצחק", label: "בארות יצחק" },
{ value: "בארותיים", label: "בארותיים" },
{ value: "בארי", label: "בארי" },
{ value: "בוסתן הגליל", label: "בוסתן הגליל" },
{ value: "בועיינה-נוג'ידאת", label: "בועיינה-נוג'ידאת" },
{ value: "בוקעאתא", label: "בוקעאתא" },
{ value: "בורגתה", label: "בורגתה" },
{ value: "בחן", label: "בחן" },
{ value: "בטחה", label: "בטחה" },
{ value: "ביצרון", label: "ביצרון" },
{ value: "ביר אל-מכסור", label: "ביר אל-מכסור" },
{ value: "ביר הדאג'", label: "ביר הדאג'" },
{ value: "ביריה", label: "ביריה" },
{ value: "בית אורן", label: "בית אורן" },
{ value: "בית אל", label: "בית אל" },
{ value: "בית אלעזרי", label: "בית אלעזרי" },
{ value: "בית אלפא", label: "בית אלפא" },
{ value: "בית אריה", label: "בית אריה" },
{ value: "בית ברל", label: "בית ברל" },
{ value: "בית גוברין", label: "בית גוברין" },
{ value: "בית גמליאל", label: "בית גמליאל" },
{ value: "בית ג'ן", label: "בית ג'ן" },
{ value: "בית דגן", label: "בית דגן" },
{ value: "בית הגדי", label: "בית הגדי" },
{ value: "בית הלוי", label: "בית הלוי" },
{ value: "בית הלל", label: "בית הלל" },
{ value: "בית העמק", label: "בית העמק" },
{ value: "בית הערבה", label: "בית הערבה" },
{ value: "בית השיטה", label: "בית השיטה" },
{ value: "בית זיד", label: "בית זיד" },
{ value: "בית זית", label: "בית זית" },
{ value: "בית זרע", label: "בית זרע" },
{ value: "בית חגלה", label: "בית חגלה" },
{ value: "בית חורון", label: "בית חורון" },
{ value: "בית חירות", label: "בית חירות" },
{ value: "בית חלקיה", label: "בית חלקיה" },
{ value: "בית חנן", label: "בית חנן" },
{ value: "בית חנניה", label: "בית חנניה" },
{ value: "בית חשמונאי", label: "בית חשמונאי" },
{ value: "בית יהושע", label: "בית יהושע" },
{ value: "בית יוסף", label: "בית יוסף" },
{ value: "בית ינאי", label: "בית ינאי" },
{ value: "בית יצחק-שער חפר", label: "בית יצחק-שער חפר" },
{ value: "בית לחם הגלילית", label: "בית לחם הגלילית" },
{ value: "בית מאיר", label: "בית מאיר" },
{ value: "בית נחמיה", label: "בית נחמיה" },
{ value: "בית ניר", label: "בית ניר" },
{ value: "בית נקופה", label: "בית נקופה" },
{ value: "בית עובד", label: "בית עובד" },
{ value: "בית עוזיאל", label: "בית עוזיאל" },
{ value: "בית עזרא", label: "בית עזרא" },
{ value: "בית עריף", label: "בית עריף" },
{ value: "בית צבי", label: "בית צבי" },
{ value: "בית קמה", label: "בית קמה" },
{ value: "בית קשת", label: "בית קשת" },
{ value: "בית רבן", label: "בית רבן" },
{ value: "בית רימון", label: "בית רימון" },
{ value: "בית שאן", label: "בית שאן" },
{ value: "בית שמש", label: "בית שמש" },
{ value: "בית שערים", label: "בית שערים" },
{ value: "בית שקמה", label: "בית שקמה" },
{ value: "ביתן אהרן", label: "ביתן אהרן" },
{ value: "ביתר עילית", label: "ביתר עילית" },
{ value: "בלפוריה", label: "בלפוריה" },
{ value: "בן זכאי", label: "בן זכאי" },
{ value: "בן עמי", label: "בן עמי" },
{ value: "בן שמן כפר נוער", label: "בן שמן כפר נוער" },
{ value: "בן שמן מושב", label: "בן שמן מושב" },
{ value: "בני ברק", label: "בני ברק" },
{ value: "בני דקלים", label: "בני דקלים" },
{ value: "בני דרום", label: "בני דרום" },
{ value: "בני דרור", label: "בני דרור" },
{ value: "בני יהודה", label: "בני יהודה" },
{ value: "בני נצרים", label: "בני נצרים" },
{ value: "בני עטרות", label: "בני עטרות" },
{ value: "בני עי\"ש", label: "בני עי\"ש" },
{ value: "בני ציון", label: "בני ציון" },
{ value: "בני ראם", label: "בני ראם" },
{ value: "בניה", label: "בניה" },
{ value: "בנימינה-גבעת עדה", label: "בנימינה-גבעת עדה" },
{ value: "סמ\"ה", label: "סמ\"ה" },
{ value: "סמת טבעון", label: "סמת טבעון" },
{ value: "בענה", label: "בענה" },
{ value: "בצרה", label: "בצרה" },
{ value: "בצת", label: "בצת" },
{ value: "בקוע", label: "בקוע" },
{ value: "בקעות", label: "בקעות" },
{ value: "בר גיורא", label: "בר גיורא" },
{ value: "בר יוחאי", label: "בר יוחאי" },
{ value: "ברוכין", label: "ברוכין" },
{ value: "ברור חיל", label: "ברור חיל" },
{ value: "ברוש", label: "ברוש" },
{ value: "ברכה", label: "ברכה" },
{ value: "ברכיה", label: "ברכיה" },
{ value: "ברעם", label: "ברעם" },
{ value: "ברק", label: "ברק" },
{ value: "ברקאי", label: "ברקאי" },
{ value: "ברקן", label: "ברקן" },
{ value: "ברקת", label: "ברקת" },
{ value: "בת הדר", label: "בת הדר" },
{ value: "בת חן", label: "בת חן" },
{ value: "בת חפר", label: "בת חפר" },
{ value: "בת ים", label: "בת ים" },
{ value: "בת עין", label: "בת עין" },
{ value: "בת שלמה", label: "בת שלמה" },
{ value: "גאולי תימן", label: "גאולי תימן" },
{ value: "גאולים", label: "גאולים" },
{ value: "גאליה", label: "גאליה" },
{ value: "גבולות", label: "גבולות" },
{ value: "גבים", label: "גבים" },
{ value: "גבע", label: "גבע" },
{ value: "גבע בנימין", label: "גבע בנימין" },
{ value: "גבע כרמל", label: "גבע כרמל" },
{ value: "גבעולים", label: "גבעולים" },
{ value: "גבעון החדשה", label: "גבעון החדשה" },
{ value: "גבעות בר", label: "גבעות בר" },
{ value: "גבעות הרואה", label: "גבעות הרואה" },
{ value: "גבעת אבני", label: "גבעת אבני" },
{ value: "גבעת אלה", label: "גבעת אלה" },
{ value: "גבעת ברנר", label: "גבעת ברנר" },
{ value: "גבעת השלושה", label: "גבעת השלושה" },
{ value: "גבעת זאב", label: "גבעת זאב" },
{ value: "גבעת חן", label: "גבעת חן" },
{ value: "גבעת חיים איחוד", label: "גבעת חיים איחוד" },
{ value: "גבעת חיים מאוחד", label: "גבעת חיים מאוחד" },
{ value: "גבעת יואב", label: "גבעת יואב" },
{ value: "גבעת יערים", label: "גבעת יערים" },
{ value: "גבעת ישעיהו", label: "גבעת ישעיהו" },
{ value: "גבעת כח", label: "גבעת כח" },
{ value: "גבעת ניל\"י", label: "גבעת ניל\"י" },
{ value: "גבעת עוז", label: "גבעת עוז" },
{ value: "גבעת שמואל", label: "גבעת שמואל" },
{ value: "גבעת שמש", label: "גבעת שמש" },
{ value: "גבעת שפירא", label: "גבעת שפירא" },
{ value: "גבעתי", label: "גבעתי" },
{ value: "גבעתיים", label: "גבעתיים" },
{ value: "גברעם", label: "גברעם" },
{ value: "גבת", label: "גבת" },
{ value: "גדות", label: "גדות" },
{ value: "ג'דיידה-מכר", label: "ג'דיידה-מכר" },
{ value: "גדיש", label: "גדיש" },
{ value: "גדעונה", label: "גדעונה" },
{ value: "גדרה", label: "גדרה" },
{ value: "ג'ולס", label: "ג'ולס" },
{ value: "גונן", label: "גונן" },
{ value: "גורן", label: "גורן" },
{ value: "גורנות הגליל", label: "גורנות הגליל" },
{ value: "גזית", label: "גזית" },
{ value: "גזר", label: "גזר" },
{ value: "גיאה", label: "גיאה" },
{ value: "גיבתון", label: "גיבתון" },
{ value: "גיזו", label: "גיזו" },
{ value: "גילון", label: "גילון" },
{ value: "גילת", label: "גילת" },
{ value: "גינוסר", label: "גינוסר" },
{ value: "גיניגר", label: "גיניגר" },
{ value: "גינתון", label: "גינתון" },
{ value: "גיתה", label: "גיתה" },
{ value: "גיתית", label: "גיתית" },
{ value: "גלאון", label: "גלאון" },
{ value: "ג'לג'וליה", label: "ג'לג'וליה" },
{ value: "גלגל", label: "גלגל" },
{ value: "גליל ים", label: "גליל ים" },
{ value: "גלעד אבן יצחק", label: "גלעד אבן יצחק" },
{ value: "גמזו", label: "גמזו" },
{ value: "גן הדרום", label: "גן הדרום" },
{ value: "גן השומרון", label: "גן השומרון" },
{ value: "גן חיים", label: "גן חיים" },
{ value: "גן יאשיה", label: "גן יאשיה" },
{ value: "גן יבנה", label: "גן יבנה" },
{ value: "גן נר", label: "גן נר" },
{ value: "גן שורק", label: "גן שורק" },
{ value: "גן שלמה", label: "גן שלמה" },
{ value: "גן שמואל", label: "גן שמואל" },
{ value: "ג'נאביב שבט", label: "ג'נאביב שבט" },
{ value: "גנות", label: "גנות" },
{ value: "גנות הדר", label: "גנות הדר" },
{ value: "גני הדר", label: "גני הדר" },
{ value: "גני טל", label: "גני טל" },
{ value: "גני יוחנן", label: "גני יוחנן" },
{ value: "גני מודיעין", label: "גני מודיעין" },
{ value: "גני עם", label: "גני עם" },
{ value: "גני תקווה", label: "גני תקווה" },
{ value: "ג'סר א-זרקא", label: "ג'סר א-זרקא" },
{ value: "געש", label: "געש" },
{ value: "געתון", label: "געתון" },
{ value: "גפן", label: "גפן" },
{ value: "גרופית", label: "גרופית" },
{ value: "ג'ש גוש חלב", label: "ג'ש גוש חלב" },
{ value: "גשור", label: "גשור" },
{ value: "גשר", label: "גשר" },
{ value: "גשר הזיו", label: "גשר הזיו" },
{ value: "ג'ת", label: "ג'ת" },
{ value: "גת קיבוץ", label: "גת קיבוץ" },
{ value: "גת רימון", label: "גת רימון" },
{ value: "דאלית אל-כרמל", label: "דאלית אל-כרמל" },
{ value: "דבורה", label: "דבורה" },
{ value: "דבוריה", label: "דבוריה" },
{ value: "דביר", label: "דביר" },
{ value: "דברת", label: "דברת" },
{ value: "דגניה א'", label: "דגניה א'" },
{ value: "דגניה ב'", label: "דגניה ב'" },
{ value: "דוב\"ב", label: "דוב\"ב" },
{ value: "דולב", label: "דולב" },
{ value: "דור", label: "דור" },
{ value: "דורות", label: "דורות" },
{ value: "דחי", label: "דחי" },
{ value: "דייר אל-אסד", label: "דייר אל-אסד" },
{ value: "דייר חנא", label: "דייר חנא" },
{ value: "דייר ראפאת", label: "דייר ראפאת" },
{ value: "דימונה", label: "דימונה" },
{ value: "דישון", label: "דישון" },
{ value: "דליה", label: "דליה" },
{ value: "דלתון", label: "דלתון" },
{ value: "דמיידה", label: "דמיידה" },
{ value: "דן", label: "דן" },
{ value: "דפנה", label: "דפנה" },
{ value: "דקל", label: "דקל" },
{ value: "דריג'את", label: "דריג'את" },
{ value: "האון", label: "האון" },
{ value: "הבונים", label: "הבונים" },
{ value: "הגושרים", label: "הגושרים" },
{ value: "הדר עם", label: "הדר עם" },
{ value: "הוד השרון", label: "הוד השרון" },
{ value: "הודיה", label: "הודיה" },
{ value: "הודיות", label: "הודיות" },
{ value: "הוואשלה שבט", label: "הוואשלה שבט" },
{ value: "הוזייל שבט", label: "הוזייל שבט" },
{ value: "הושעיה", label: "הושעיה" },
{ value: "הזורע", label: "הזורע" },
{ value: "הזורעים", label: "הזורעים" },
{ value: "החותרים", label: "החותרים" },
{ value: "היוגב", label: "היוגב" },
{ value: "הילה", label: "הילה" },
{ value: "המעפיל", label: "המעפיל" },
{ value: "הסוללים", label: "הסוללים" },
{ value: "העוגן", label: "העוגן" },
{ value: "הר אדר", label: "הר אדר" },
{ value: "הר גילה", label: "הר גילה" },
{ value: "הר עמשא", label: "הר עמשא" },
{ value: "הראל", label: "הראל" },
{ value: "הרדוף", label: "הרדוף" },
{ value: "הרצליה", label: "הרצליה" },
{ value: "הררית", label: "הררית" },
{ value: "ורד יריחו", label: "ורד יריחו" },
{ value: "ורדון", label: "ורדון" },
{ value: "זבארגה שבט", label: "זבארגה שבט" },
{ value: "זבדיאל", label: "זבדיאל" },
{ value: "זוהר", label: "זוהר" },
{ value: "זיקים", label: "זיקים" },
{ value: "זיתן", label: "זיתן" },
{ value: "זכרון יעקב", label: "זכרון יעקב" },
{ value: "זכריה", label: "זכריה" },
{ value: "זמר", label: "זמר" },
{ value: "זמרת", label: "זמרת" },
{ value: "זנוח", label: "זנוח" },
{ value: "זרועה", label: "זרועה" },
{ value: "זרזיר", label: "זרזיר" },
{ value: "זרחיה", label: "זרחיה" },
{ value: "חבצלת השרון", label: "חבצלת השרון" },
{ value: "חבר", label: "חבר" },
{ value: "חברון", label: "חברון" },
{ value: "חגור", label: "חגור" },
{ value: "חגי", label: "חגי" },
{ value: "חגלה", label: "חגלה" },
{ value: "חדיד", label: "חדיד" },
{ value: "חד-נס", label: "חד-נס" },
{ value: "חדרה", label: "חדרה" },
{ value: "ח'ואלד", label: "ח'ואלד" },
{ value: "ח'ואלד שבט", label: "ח'ואלד שבט" },
{ value: "חוג'ייראת ד'הרה", label: "חוג'ייראת ד'הרה" },
{ value: "חולדה", label: "חולדה" },
{ value: "חולון", label: "חולון" },
{ value: "חולון", label: "חולון" },
{ value: "חולית", label: "חולית" },
{ value: "חולתה", label: "חולתה" },
{ value: "חוסן", label: "חוסן" },
{ value: "חוסנייה", label: "חוסנייה" },
{ value: "חופית", label: "חופית" },
{ value: "חוקוק", label: "חוקוק" },
{ value: "חורה", label: "חורה" },
{ value: "חורפיש", label: "חורפיש" },
{ value: "חורשים", label: "חורשים" },
{ value: "חזון", label: "חזון" },
{ value: "חיבת ציון", label: "חיבת ציון" },
{ value: "חיננית", label: "חיננית" },
{ value: "חיפה", label: "חיפה" },
{ value: "חיפה", label: "חיפה" },
{ value: "חירות", label: "חירות" },
{ value: "חלוץ", label: "חלוץ" },
{ value: "חלץ", label: "חלץ" },
{ value: "חמאם", label: "חמאם" },
{ value: "חמד", label: "חמד" },
{ value: "חמדיה", label: "חמדיה" },
{ value: "חמדת", label: "חמדת" },
{ value: "חמרה", label: "חמרה" },
{ value: "חניאל", label: "חניאל" },
{ value: "חניתה", label: "חניתה" },
{ value: "חנתון", label: "חנתון" },
{ value: "חספין", label: "חספין" },
{ value: "חפץ חיים", label: "חפץ חיים" },
{ value: "חפצי-בה", label: "חפצי-בה" },
{ value: "חצב", label: "חצב" },
{ value: "חצבה", label: "חצבה" },
{ value: "חצור הגלילית", label: "חצור הגלילית" },
{ value: "חצור-אשדוד", label: "חצור-אשדוד" },
{ value: "חצרים", label: "חצרים" },
{ value: "חרב לאת", label: "חרב לאת" },
{ value: "חרוצים", label: "חרוצים" },
{ value: "חריש", label: "חריש" },
{ value: "חרמש", label: "חרמש" },
{ value: "חרשים", label: "חרשים" },
{ value: "חשמונאים", label: "חשמונאים" },
{ value: "טבריה", label: "טבריה" },
{ value: "טובא-זנגריה", label: "טובא-זנגריה" },
{ value: "טורעאן", label: "טורעאן" },
{ value: "טייבה", label: "טייבה" },
{ value: "טייבה בעמק", label: "טייבה בעמק" },
{ value: "טירה", label: "טירה" },
{ value: "טירת יהודה", label: "טירת יהודה" },
{ value: "טירת כרמל", label: "טירת כרמל" },
{ value: "טירת צבי", label: "טירת צבי" },
{ value: "טל שחר", label: "טל שחר" },
{ value: "טל-אל", label: "טל-אל" },
{ value: "טללים", label: "טללים" },
{ value: "טלמון", label: "טלמון" },
{ value: "טמרה", label: "טמרה" },
{ value: "טמרה יזרעאל", label: "טמרה יזרעאל" },
{ value: "טנא", label: "טנא" },
{ value: "טפחות", label: "טפחות" },
{ value: "יאנוח-ג'ת", label: "יאנוח-ג'ת" },
{ value: "יבול", label: "יבול" },
{ value: "יבנאל", label: "יבנאל" },
{ value: "יבנה", label: "יבנה" },
{ value: "יגור", label: "יגור" },
{ value: "יגל", label: "יגל" },
{ value: "יד בנימין", label: "יד בנימין" },
{ value: "יד השמונה", label: "יד השמונה" },
{ value: "יד חנה", label: "יד חנה" },
{ value: "יד מרדכי", label: "יד מרדכי" },
{ value: "יד נתן", label: "יד נתן" },
{ value: "יד רמב\"ם", label: "יד רמב\"ם" },
{ value: "ידידה", label: "ידידה" },
{ value: "יהוד-מונוסון", label: "יהוד-מונוסון" },
{ value: "יהל", label: "יהל" },
{ value: "יובל", label: "יובל" },
{ value: "יובלים", label: "יובלים" },
{ value: "יודפת", label: "יודפת" },
{ value: "יונתן", label: "יונתן" },
{ value: "יושיביה", label: "יושיביה" },
{ value: "יזרעאל", label: "יזרעאל" },
{ value: "יחיעם", label: "יחיעם" },
{ value: "יטבתה", label: "יטבתה" },
{ value: "ייט\"ב", label: "ייט\"ב" },
{ value: "יכיני", label: "יכיני" },
{ value: "ינוב", label: "ינוב" },
{ value: "ינון", label: "ינון" },
{ value: "יסוד המעלה", label: "יסוד המעלה" },
{ value: "יסודות", label: "יסודות" },
{ value: "יסעור", label: "יסעור" },
{ value: "יעד", label: "יעד" },
{ value: "יעל", label: "יעל" },
{ value: "יעף", label: "יעף" },
{ value: "יערה", label: "יערה" },
{ value: "יפיע", label: "יפיע" },
{ value: "יפית", label: "יפית" },
{ value: "יפעת", label: "יפעת" },
{ value: "יפתח", label: "יפתח" },
{ value: "יצהר", label: "יצהר" },
{ value: "יציץ", label: "יציץ" },
{ value: "יקום", label: "יקום" },
{ value: "יקיר", label: "יקיר" },
{ value: "יקנעם מושבה", label: "יקנעם מושבה" },
{ value: "יקנעם עילית", label: "יקנעם עילית" },
{ value: "יראון", label: "יראון" },
{ value: "ירדנה", label: "ירדנה" },
{ value: "ירוחם", label: "ירוחם" },
{ value: "ירושלים", label: "ירושלים" },
{ value: "ירחיב", label: "ירחיב" },
{ value: "ירכא", label: "ירכא" },
{ value: "ירקונה", label: "ירקונה" },
{ value: "ישע", label: "ישע" },
{ value: "ישעי", label: "ישעי" },
{ value: "ישרש", label: "ישרש" },
{ value: "יתד", label: "יתד" },
{ value: "כאבול", label: "כאבול" },
{ value: "כאוכב אבו אל-היג'א", label: "כאוכב אבו אל-היג'א" },
{ value: "כברי", label: "כברי" },
{ value: "כדורי", label: "כדורי" },
{ value: "כדיתה", label: "כדיתה" },
{ value: "כוכב השחר", label: "כוכב השחר" },
{ value: "כוכב יאיר", label: "כוכב יאיר" },
{ value: "כוכב יעקב", label: "כוכב יעקב" },
{ value: "כוכב מיכאל", label: "כוכב מיכאל" },
{ value: "כורזים", label: "כורזים" },
{ value: "כחל", label: "כחל" },
{ value: "כחלה", label: "כחלה" },
{ value: "כיסופים", label: "כיסופים" },
{ value: "כישור", label: "כישור" },
{ value: "כליל", label: "כליל" },
{ value: "כלנית", label: "כלנית" },
{ value: "כמאנה", label: "כמאנה" },
{ value: "כמהין", label: "כמהין" },
{ value: "כמון", label: "כמון" },
{ value: "כנות", label: "כנות" },
{ value: "כנף", label: "כנף" },
{ value: "כנרת מושבה", label: "כנרת מושבה" },
{ value: "כנרת קבוצה", label: "כנרת קבוצה" },
{ value: "כסיפה", label: "כסיפה" },
{ value: "כסלון", label: "כסלון" },
{ value: "כסרא-סמיע", label: "כסרא-סמיע" },
{ value: "כעביה-טבאש-חג'אג'רה", label: "כעביה-טבאש-חג'אג'רה" },
{ value: "כפר אביב", label: "כפר אביב" },
{ value: "כפר אדומים", label: "כפר אדומים" },
{ value: "כפר אוריה", label: "כפר אוריה" },
{ value: "כפר אחים", label: "כפר אחים" },
{ value: "כפר ביאליק", label: "כפר ביאליק" },
{ value: "כפר ביל\"ו", label: "כפר ביל\"ו" },
{ value: "כפר בלום", label: "כפר בלום" },
{ value: "כפר בן נון", label: "כפר בן נון" },
{ value: "כפר ברא", label: "כפר ברא" },
{ value: "כפר ברוך", label: "כפר ברוך" },
{ value: "כפר גדעון", label: "כפר גדעון" },
{ value: "כפר גלים", label: "כפר גלים" },
{ value: "כפר גליקסון", label: "כפר גליקסון" },
{ value: "כפר גלעדי", label: "כפר גלעדי" },
{ value: "כפר דניאל", label: "כפר דניאל" },
{ value: "כפר האורנים", label: "כפר האורנים" },
{ value: "כפר החורש", label: "כפר החורש" },
{ value: "כפר המכבי", label: "כפר המכבי" },
{ value: "כפר הנגיד", label: "כפר הנגיד" },
{ value: "כפר הנוער הדתי", label: "כפר הנוער הדתי" },
{ value: "כפר הנשיא", label: "כפר הנשיא" },
{ value: "כפר הס", label: "כפר הס" },
{ value: "כפר הרא\"ה", label: "כפר הרא\"ה" },
{ value: "כפר הרי\"ף", label: "כפר הרי\"ף" },
{ value: "כפר ויתקין", label: "כפר ויתקין" },
{ value: "כפר ורבורג", label: "כפר ורבורג" },
{ value: "כפר ורדים", label: "כפר ורדים" },
{ value: "כפר זוהרים", label: "כפר זוהרים" },
{ value: "כפר זיתים", label: "כפר זיתים" },
{ value: "כפר חב\"ד", label: "כפר חב\"ד" },
{ value: "כפר חושן", label: "כפר חושן" },
{ value: "כפר חיטים", label: "כפר חיטים" },
{ value: "כפר חיים", label: "כפר חיים" },
{ value: "כפר חנניה", label: "כפר חנניה" },
{ value: "כפר חסידים א'", label: "כפר חסידים א'" },
{ value: "כפר חסידים ב'", label: "כפר חסידים ב'" },
{ value: "כפר חרוב", label: "כפר חרוב" },
{ value: "כפר טרומן", label: "כפר טרומן" },
{ value: "כפר יאסיף", label: "כפר יאסיף" },
{ value: "כפר ידידיה", label: "כפר ידידיה" },
{ value: "כפר יהושע", label: "כפר יהושע" },
{ value: "כפר יונה", label: "כפר יונה" },
{ value: "כפר יחזקאל", label: "כפר יחזקאל" },
{ value: "כפר יעבץ", label: "כפר יעבץ" },
{ value: "כפר כמא", label: "כפר כמא" },
{ value: "כפר כנא", label: "כפר כנא" },
{ value: "כפר מונש", label: "כפר מונש" },
{ value: "כפר מימון", label: "כפר מימון" },
{ value: "כפר מל\"ל", label: "כפר מל\"ל" },
{ value: "כפר מנדא", label: "כפר מנדא" },
{ value: "כפר מנחם", label: "כפר מנחם" },
{ value: "כפר מסריק", label: "כפר מסריק" },
{ value: "כפר מצר", label: "כפר מצר" },
{ value: "כפר מרדכי", label: "כפר מרדכי" },
{ value: "כפר נטר", label: "כפר נטר" },
{ value: "כפר סאלד", label: "כפר סאלד" },
{ value: "כפר סבא", label: "כפר סבא" },
{ value: "כפר סילבר", label: "כפר סילבר" },
{ value: "כפר סירקין", label: "כפר סירקין" },
{ value: "כפר עבודה", label: "כפר עבודה" },
{ value: "כפר עזה", label: "כפר עזה" },
{ value: "כפר עציון", label: "כפר עציון" },
{ value: "כפר פינס", label: "כפר פינס" },
{ value: "כפר קאסם", label: "כפר קאסם" },
{ value: "כפר קיש", label: "כפר קיש" },
{ value: "כפר קרע", label: "כפר קרע" },
{ value: "כפר ראש הנקרה", label: "כפר ראש הנקרה" },
{ value: "כפר רוזנואלד זרעית", label: "כפר רוזנואלד זרעית" },
{ value: "כפר רופין", label: "כפר רופין" },
{ value: "כפר רות", label: "כפר רות" },
{ value: "כפר שמאי", label: "כפר שמאי" },
{ value: "כפר שמואל", label: "כפר שמואל" },
{ value: "כפר שמריהו", label: "כפר שמריהו" },
{ value: "כפר תבור", label: "כפר תבור" },
{ value: "כפר תפוח", label: "כפר תפוח" },
{ value: "כרי דשא", label: "כרי דשא" },
{ value: "כרכום", label: "כרכום" },
{ value: "כרם ביבנה ישיבה", label: "כרם ביבנה ישיבה" },
{ value: "כרם בן זמרה", label: "כרם בן זמרה" },
{ value: "כרם בן שמן", label: "כרם בן שמן" },
{ value: "כרם מהר\"ל", label: "כרם מהר\"ל" },
{ value: "כרם שלום", label: "כרם שלום" },
{ value: "כרמי יוסף", label: "כרמי יוסף" },
{ value: "כרמי צור", label: "כרמי צור" },
{ value: "כרמי קטיף", label: "כרמי קטיף" },
{ value: "כרמיאל", label: "כרמיאל" },
{ value: "כרמיה", label: "כרמיה" },
{ value: "כרמים", label: "כרמים" },
{ value: "כרמל", label: "כרמל" },
{ value: "לבון", label: "לבון" },
{ value: "לביא", label: "לביא" },
{ value: "לבנים", label: "לבנים" },
{ value: "להב", label: "להב" },
{ value: "להבות הבשן", label: "להבות הבשן" },
{ value: "להבות חביבה", label: "להבות חביבה" },
{ value: "להבים", label: "להבים" },
{ value: "לוד", label: "לוד" },
{ value: "לוזית", label: "לוזית" },
{ value: "לוחמי הגיטאות", label: "לוחמי הגיטאות" },
{ value: "לוטם", label: "לוטם" },
{ value: "לוטן", label: "לוטן" },
{ value: "לימן", label: "לימן" },
{ value: "לכיש", label: "לכיש" },
{ value: "לפיד", label: "לפיד" },
{ value: "לפידות", label: "לפידות" },
{ value: "לקיה", label: "לקיה" },
{ value: "מאור", label: "מאור" },
{ value: "מאיר שפיה", label: "מאיר שפיה" },
{ value: "מבוא ביתר", label: "מבוא ביתר" },
{ value: "מבוא דותן", label: "מבוא דותן" },
{ value: "מבוא חורון", label: "מבוא חורון" },
{ value: "מבוא חמה", label: "מבוא חמה" },
{ value: "מבוא מודיעים", label: "מבוא מודיעים" },
{ value: "מבואות ים", label: "מבואות ים" },
{ value: "מבואות יריחו", label: "מבואות יריחו" },
{ value: "מבועים", label: "מבועים" },
{ value: "מבטחים", label: "מבטחים" },
{ value: "מבקיעים", label: "מבקיעים" },
{ value: "מבשרת ציון", label: "מבשרת ציון" },
{ value: "מגאר", label: "מגאר" },
{ value: "מג'ד אל-כרום", label: "מג'ד אל-כרום" },
{ value: "מגדים", label: "מגדים" },
{ value: "מגדל", label: "מגדל" },
{ value: "מגדל העמק", label: "מגדל העמק" },
{ value: "מגדל עוז", label: "מגדל עוז" },
{ value: "מג'דל שמס", label: "מג'דל שמס" },
{ value: "מגדלים", label: "מגדלים" },
{ value: "מגידו", label: "מגידו" },
{ value: "מגל", label: "מגל" },
{ value: "מגן", label: "מגן" },
{ value: "מגן שאול", label: "מגן שאול" },
{ value: "מגשימים", label: "מגשימים" },
{ value: "מדרך עוז", label: "מדרך עוז" },
{ value: "מדרשת בן גוריון", label: "מדרשת בן גוריון" },
{ value: "מדרשת רופין", label: "מדרשת רופין" },
{ value: "מודיעין עילית", label: "מודיעין עילית" },
{ value: "מודיעין-מכבים-רעות", label: "מודיעין-מכבים-רעות" },
{ value: "מולדת", label: "מולדת" },
{ value: "מוצא עילית", label: "מוצא עילית" },
{ value: "מוקייבלה", label: "מוקייבלה" },
{ value: "מורן", label: "מורן" },
{ value: "מורשת", label: "מורשת" },
{ value: "מזור", label: "מזור" },
{ value: "מזכרת בתיה", label: "מזכרת בתיה" },
{ value: "מזרע", label: "מזרע" },
{ value: "מזרעה", label: "מזרעה" },
{ value: "מחולה", label: "מחולה" },
{ value: "מחנה הילה", label: "מחנה הילה" },
{ value: "מחנה טלי", label: "מחנה טלי" },
{ value: "מכורה", label: "מכורה" },
{ value: "מכחול", label: "מכחול" },
{ value: "מכמורת", label: "מכמורת" },
{ value: "מכמנים", label: "מכמנים" },
{ value: "מלאה", label: "מלאה" },
{ value: "מלילות", label: "מלילות" },
{ value: "מלכיה", label: "מלכיה" },
{ value: "מנוחה", label: "מנוחה" },
{ value: "מנוף", label: "מנוף" },
{ value: "מנות", label: "מנות" },
{ value: "מנחמיה", label: "מנחמיה" },
{ value: "מנרה", label: "מנרה" },
{ value: "מנשית זבדה", label: "מנשית זבדה" },
{ value: "מסד", label: "מסד" },
{ value: "מסדה", label: "מסדה" },
{ value: "מסילות", label: "מסילות" },
{ value: "מסילת ציון", label: "מסילת ציון" },
{ value: "מסלול", label: "מסלול" },
{ value: "מסעדה", label: "מסעדה" },
{ value: "מסעודין אל-עזאזמה", label: "מסעודין אל-עזאזמה" },
{ value: "מעברות", label: "מעברות" },
{ value: "מעגלים", label: "מעגלים" },
{ value: "מעגן", label: "מעגן" },
{ value: "מעגן מיכאל", label: "מעגן מיכאל" },
{ value: "מעוז חיים", label: "מעוז חיים" },
{ value: "מעון", label: "מעון" },
{ value: "מעונה", label: "מעונה" },
{ value: "מעיליא", label: "מעיליא" },
{ value: "מעין ברוך", label: "מעין ברוך" },
{ value: "מעין צבי", label: "מעין צבי" },
{ value: "מעלה אדומים", label: "מעלה אדומים" },
{ value: "מעלה אפרים", label: "מעלה אפרים" },
{ value: "מעלה גלבוע", label: "מעלה גלבוע" },
{ value: "מעלה גמלא", label: "מעלה גמלא" },
{ value: "מעלה החמישה", label: "מעלה החמישה" },
{ value: "מעלה לבונה", label: "מעלה לבונה" },
{ value: "מעלה מכמש", label: "מעלה מכמש" },
{ value: "מעלה עירון", label: "מעלה עירון" },
{ value: "מעלה עמוס", label: "מעלה עמוס" },
{ value: "מעלות-תרשיחא", label: "מעלות-תרשיחא" },
{ value: "מענית", label: "מענית" },
{ value: "מעש", label: "מעש" },
{ value: "מפלסים", label: "מפלסים" },
{ value: "מצדות יהודה", label: "מצדות יהודה" },
{ value: "מצובה", label: "מצובה" },
{ value: "מצליח", label: "מצליח" },
{ value: "מצפה", label: "מצפה" },
{ value: "מצפה אבי\"ב", label: "מצפה אבי\"ב" },
{ value: "מצפה אילן", label: "מצפה אילן" },
{ value: "מצפה יריחו", label: "מצפה יריחו" },
{ value: "מצפה נטופה", label: "מצפה נטופה" },
{ value: "מצפה רמון", label: "מצפה רמון" },
{ value: "מצפה שלם", label: "מצפה שלם" },
{ value: "מצר", label: "מצר" },
{ value: "מקווה ישראל", label: "מקווה ישראל" },
{ value: "מרגליות", label: "מרגליות" },
{ value: "מרום גולן", label: "מרום גולן" },
{ value: "מרחב עם", label: "מרחב עם" },
{ value: "מרחביה מושב", label: "מרחביה מושב" },
{ value: "מרחביה קיבוץ", label: "מרחביה קיבוץ" },
{ value: "מרכז שפירא", label: "מרכז שפירא" },
{ value: "משאבי שדה", label: "משאבי שדה" },
{ value: "משגב דב", label: "משגב דב" },
{ value: "משגב עם", label: "משגב עם" },
{ value: "משהד", label: "משהד" },
{ value: "משואה", label: "משואה" },
{ value: "משואות יצחק", label: "משואות יצחק" },
{ value: "משכיות", label: "משכיות" },
{ value: "משמר איילון", label: "משמר איילון" },
{ value: "משמר דוד", label: "משמר דוד" },
{ value: "משמר הירדן", label: "משמר הירדן" },
{ value: "משמר הנגב", label: "משמר הנגב" },
{ value: "משמר העמק", label: "משמר העמק" },
{ value: "משמר השבעה", label: "משמר השבעה" },
{ value: "משמר השרון", label: "משמר השרון" },
{ value: "משמר יהודה", label: "משמר יהודה" },
{ value: "משמרות", label: "משמרות" },
{ value: "משמרת", label: "משמרת" },
{ value: "משען", label: "משען" },
{ value: "מתן", label: "מתן" },
{ value: "מתת", label: "מתת" },
{ value: "מתתיהו", label: "מתתיהו" },
{ value: "נאות גולן", label: "נאות גולן" },
{ value: "נאות הכיכר", label: "נאות הכיכר" },
{ value: "נאות מרדכי", label: "נאות מרדכי" },
{ value: "נאות סמדר", label: "נאות סמדר" },
{ value: "נאעורה", label: "נאעורה" },
{ value: "נבטים", label: "נבטים" },
{ value: "נגבה", label: "נגבה" },
{ value: "נגוהות", label: "נגוהות" },
{ value: "נהורה", label: "נהורה" },
{ value: "נהלל", label: "נהלל" },
{ value: "נהריה", label: "נהריה" },
{ value: "נוב", label: "נוב" },
{ value: "נוגה", label: "נוגה" },
{ value: "נוה צוף", label: "נוה צוף" },
{ value: "נווה", label: "נווה" },
{ value: "נווה אבות", label: "נווה אבות" },
{ value: "נווה אור", label: "נווה אור" },
{ value: "נווה אטי\"ב", label: "נווה אטי\"ב" },
{ value: "נווה אילן", label: "נווה אילן" },
{ value: "נווה איתן", label: "נווה איתן" },
{ value: "נווה דניאל", label: "נווה דניאל" },
{ value: "נווה זוהר", label: "נווה זוהר" },
{ value: "נווה זיו", label: "נווה זיו" },
{ value: "נווה חריף", label: "נווה חריף" },
{ value: "נווה ים", label: "נווה ים" },
{ value: "נווה ימין", label: "נווה ימין" },
{ value: "נווה ירק", label: "נווה ירק" },
{ value: "נווה מבטח", label: "נווה מבטח" },
{ value: "נווה מיכאל", label: "נווה מיכאל" },
{ value: "נווה שלום", label: "נווה שלום" },
{ value: "נועם", label: "נועם" },
{ value: "נוף איילון", label: "נוף איילון" },
{ value: "נוף הגליל", label: "נוף הגליל" },
{ value: "נופים", label: "נופים" },
{ value: "נופית", label: "נופית" },
{ value: "נופך", label: "נופך" },
{ value: "נוקדים", label: "נוקדים" },
{ value: "נורדיה", label: "נורדיה" },
{ value: "נורית", label: "נורית" },
{ value: "נחושה", label: "נחושה" },
{ value: "נחל עוז", label: "נחל עוז" },
{ value: "נחלה", label: "נחלה" },
{ value: "נחליאל", label: "נחליאל" },
{ value: "נחלים", label: "נחלים" },
{ value: "נחם", label: "נחם" },
{ value: "נחף", label: "נחף" },
{ value: "נחשולים", label: "נחשולים" },
{ value: "נחשון", label: "נחשון" },
{ value: "נחשונים", label: "נחשונים" },
{ value: "נטועה", label: "נטועה" },
{ value: "נטור", label: "נטור" },
{ value: "נטע", label: "נטע" },
{ value: "נטעים", label: "נטעים" },
{ value: "נטף", label: "נטף" },
{ value: "ניין", label: "ניין" },
{ value: "ניל\"י", label: "ניל\"י" },
{ value: "ניצן", label: "ניצן" },
{ value: "ניצן ב'", label: "ניצן ב'" },
{ value: "ניצנה קהילת חינוך", label: "ניצנה קהילת חינוך" },
{ value: "ניצני סיני", label: "ניצני סיני" },
{ value: "ניצני עוז", label: "ניצני עוז" },
{ value: "ניצנים", label: "ניצנים" },
{ value: "ניר אליהו", label: "ניר אליהו" },
{ value: "ניר בנים", label: "ניר בנים" },
{ value: "ניר גלים", label: "ניר גלים" },
{ value: "ניר דוד תל עמל", label: "ניר דוד תל עמל" },
{ value: "ניר ח\"ן", label: "ניר ח\"ן" },
{ value: "ניר יפה", label: "ניר יפה" },
{ value: "ניר יצחק", label: "ניר יצחק" },
{ value: "ניר ישראל", label: "ניר ישראל" },
{ value: "ניר משה", label: "ניר משה" },
{ value: "ניר עוז", label: "ניר עוז" },
{ value: "ניר עם", label: "ניר עם" },
{ value: "ניר עציון", label: "ניר עציון" },
{ value: "ניר עקיבא", label: "ניר עקיבא" },
{ value: "ניר צבי", label: "ניר צבי" },
{ value: "נירים", label: "נירים" },
{ value: "נירית", label: "נירית" },
{ value: "נמרוד", label: "נמרוד" },
{ value: "נס הרים", label: "נס הרים" },
{ value: "נס עמים", label: "נס עמים" },
{ value: "נס ציונה", label: "נס ציונה" },
{ value: "נעורים", label: "נעורים" },
{ value: "נעלה", label: "נעלה" },
{ value: "נעמ\"ה", label: "נעמ\"ה" },
{ value: "נען", label: "נען" },
{ value: "נערן", label: "נערן" },
{ value: "נצאצרה שבט", label: "נצאצרה שבט" },
{ value: "נצר חזני", label: "נצר חזני" },
{ value: "נצר סרני", label: "נצר סרני" },
{ value: "נצרת", label: "נצרת" },
{ value: "נשר", label: "נשר" },
{ value: "נתיב הגדוד", label: "נתיב הגדוד" },
{ value: "נתיב הל\"ה", label: "נתיב הל\"ה" },
{ value: "נתיב העשרה", label: "נתיב העשרה" },
{ value: "נתיב השיירה", label: "נתיב השיירה" },
{ value: "נתיבות", label: "נתיבות" },
{ value: "נתניה", label: "נתניה" },
{ value: "סאג'ור", label: "סאג'ור" },
{ value: "סאסא", label: "סאסא" },
{ value: "סביון", label: "סביון" },
{ value: "סגולה", label: "סגולה" },
{ value: "סואעד חמרייה", label: "סואעד חמרייה" },
{ value: "סואעד כמאנה שבט", label: "סואעד כמאנה שבט" },
{ value: "סולם", label: "סולם" },
{ value: "סוסיה", label: "סוסיה" },
{ value: "סופה", label: "סופה" },
{ value: "סח'נין", label: "סח'נין" },
{ value: "סייד שבט", label: "סייד שבט" },
{ value: "סלמה", label: "סלמה" },
{ value: "סלעית", label: "סלעית" },
{ value: "סמר", label: "סמר" },
{ value: "סנסנה", label: "סנסנה" },
{ value: "סעד", label: "סעד" },
{ value: "סעוה", label: "סעוה" },
{ value: "סער", label: "סער" },
{ value: "ספיר", label: "ספיר" },
{ value: "סתריה", label: "סתריה" },
{ value: "עבדון", label: "עבדון" },
{ value: "עברון", label: "עברון" },
{ value: "עגור", label: "עגור" },
{ value: "ע'ג'ר", label: "ע'ג'ר" },
{ value: "עדי", label: "עדי" },
{ value: "עדנים", label: "עדנים" },
{ value: "עוזה", label: "עוזה" },
{ value: "עוזייר", label: "עוזייר" },
{ value: "עולש", label: "עולש" },
{ value: "עומר", label: "עומר" },
{ value: "עופר", label: "עופר" },
{ value: "עופרה", label: "עופרה" },
{ value: "עוצם", label: "עוצם" },
{ value: "עוקבי בנו עוקבה", label: "עוקבי בנו עוקבה" },
{ value: "עזוז", label: "עזוז" },
{ value: "עזר", label: "עזר" },
{ value: "עזריאל", label: "עזריאל" },
{ value: "עזריה", label: "עזריה" },
{ value: "עזריקם", label: "עזריקם" },
{ value: "עטאוונה שבט", label: "עטאוונה שבט" },
{ value: "עטרת", label: "עטרת" },
{ value: "עידן", label: "עידן" },
{ value: "עיילבון", label: "עיילבון" },
{ value: "עיינות", label: "עיינות" },
{ value: "עילוט", label: "עילוט" },
{ value: "עין איילה", label: "עין איילה" },
{ value: "עין אל-אסד", label: "עין אל-אסד" },
{ value: "עין גב", label: "עין גב" },
{ value: "עין גדי", label: "עין גדי" },
{ value: "עין דור", label: "עין דור" },
{ value: "עין הבשור", label: "עין הבשור" },
{ value: "עין הוד", label: "עין הוד" },
{ value: "עין החורש", label: "עין החורש" },
{ value: "עין המפרץ", label: "עין המפרץ" },
{ value: "עין הנצי\"ב", label: "עין הנצי\"ב" },
{ value: "עין העמק", label: "עין העמק" },
{ value: "עין השופט", label: "עין השופט" },
{ value: "עין השלושה", label: "עין השלושה" },
{ value: "עין ורד", label: "עין ורד" },
{ value: "עין זיוון", label: "עין זיוון" },
{ value: "עין חוד", label: "עין חוד" },
{ value: "עין חצבה", label: "עין חצבה" },
{ value: "עין חרוד איחוד", label: "עין חרוד איחוד" },
{ value: "עין חרוד מאוחד", label: "עין חרוד מאוחד" },
{ value: "עין יהב", label: "עין יהב" },
{ value: "עין יעקב", label: "עין יעקב" },
{ value: "עין כרם-בי\"ס חקלאי", label: "עין כרם-בי\"ס חקלאי" },
{ value: "עין כרמל", label: "עין כרמל" },
{ value: "עין מאהל", label: "עין מאהל" },
{ value: "עין נקובא", label: "עין נקובא" },
{ value: "עין עירון", label: "עין עירון" },
{ value: "עין צורים", label: "עין צורים" },
{ value: "עין קנייא", label: "עין קנייא" },
{ value: "עין ראפה", label: "עין ראפה" },
{ value: "עין שמר", label: "עין שמר" },
{ value: "עין שריד", label: "עין שריד" },
{ value: "עין תמר", label: "עין תמר" },
{ value: "עינת", label: "עינת" },
{ value: "עיר אובות", label: "עיר אובות" },
{ value: "עכו", label: "עכו" },
{ value: "עלומים", label: "עלומים" },
{ value: "עלי", label: "עלי" },
{ value: "עלי זהב", label: "עלי זהב" },
{ value: "עלמה", label: "עלמה" },
{ value: "עלמון", label: "עלמון" },
{ value: "עמוקה", label: "עמוקה" },
{ value: "עמיחי", label: "עמיחי" },
{ value: "עמינדב", label: "עמינדב" },
{ value: "עמיעד", label: "עמיעד" },
{ value: "עמיעוז", label: "עמיעוז" },
{ value: "עמיקם", label: "עמיקם" },
{ value: "עמיר", label: "עמיר" },
{ value: "עמנואל", label: "עמנואל" },
{ value: "עמקה", label: "עמקה" },
{ value: "ענב", label: "ענב" },
{ value: "עספיא", label: "עספיא" },
{ value: "עפולה", label: "עפולה" },
{ value: "עצמון שגב", label: "עצמון שגב" },
{ value: "עראבה", label: "עראבה" },
{ value: "עראמשה", label: "עראמשה" },
{ value: "ערב אל נעים", label: "ערב אל נעים" },
{ value: "ערד", label: "ערד" },
{ value: "ערוגות", label: "ערוגות" },
{ value: "ערערה", label: "ערערה" },
{ value: "ערערה-בנגב", label: "ערערה-בנגב" },
{ value: "עשהאל", label: "עשהאל" },
{ value: "עשרת", label: "עשרת" },
{ value: "עתלית", label: "עתלית" },
{ value: "עתניאל", label: "עתניאל" },
{ value: "פארן", label: "פארן" },
{ value: "פדואל", label: "פדואל" },
{ value: "פדויים", label: "פדויים" },
{ value: "פדיה", label: "פדיה" },
{ value: "פוריה - כפר עבודה", label: "פוריה - כפר עבודה" },
{ value: "פוריה - נווה עובד", label: "פוריה - נווה עובד" },
{ value: "פוריה עילית", label: "פוריה עילית" },
{ value: "פוריידיס", label: "פוריידיס" },
{ value: "פורת", label: "פורת" },
{ value: "פטיש", label: "פטיש" },
{ value: "פלך", label: "פלך" },
{ value: "פלמחים", label: "פלמחים" },
{ value: "פני חבר", label: "פני חבר" },
{ value: "פסגות", label: "פסגות" },
{ value: "פסוטה", label: "פסוטה" },
{ value: "פעמי תש\"ז", label: "פעמי תש\"ז" },
{ value: "פצאל", label: "פצאל" },
{ value: "פקיעין בוקייעה", label: "פקיעין בוקייעה" },
{ value: "פקיעין חדשה", label: "פקיעין חדשה" },
{ value: "פרדס חנה-כרכור", label: "פרדס חנה-כרכור" },
{ value: "פרדסיה", label: "פרדסיה" },
{ value: "פרוד", label: "פרוד" },
{ value: "פרזון", label: "פרזון" },
{ value: "פרי גן", label: "פרי גן" },
{ value: "פתח תקווה", label: "פתח תקווה" },
{ value: "פתחיה", label: "פתחיה" },
{ value: "צאלים", label: "צאלים" },
{ value: "צביה", label: "צביה" },
{ value: "צבעון", label: "צבעון" },
{ value: "צובה", label: "צובה" },
{ value: "צוחר", label: "צוחר" },
{ value: "צופיה", label: "צופיה" },
{ value: "צופים", label: "צופים" },
{ value: "צופית", label: "צופית" },
{ value: "צופר", label: "צופר" },
{ value: "צוקי ים", label: "צוקי ים" },
{ value: "צוקים", label: "צוקים" },
{ value: "צור הדסה", label: "צור הדסה" },
{ value: "צור יצחק", label: "צור יצחק" },
{ value: "צור משה", label: "צור משה" },
{ value: "צור נתן", label: "צור נתן" },
{ value: "צוריאל", label: "צוריאל" },
{ value: "צורית", label: "צורית" },
{ value: "ציפורי", label: "ציפורי" },
{ value: "צלפון", label: "צלפון" },
{ value: "צנדלה", label: "צנדלה" },
{ value: "צפריה", label: "צפריה" },
{ value: "צפרירים", label: "צפרירים" },
{ value: "צפת", label: "צפת" },
{ value: "צרופה", label: "צרופה" },
{ value: "צרעה", label: "צרעה" },
{ value: "קבועה שבט", label: "קבועה שבט" },
{ value: "קבוצת יבנה", label: "קבוצת יבנה" },
{ value: "קדומים", label: "קדומים" },
{ value: "קדימה-צורן", label: "קדימה-צורן" },
{ value: "קדמה", label: "קדמה" },
{ value: "קדמת צבי", label: "קדמת צבי" },
{ value: "קדר", label: "קדר" },
{ value: "קדרון", label: "קדרון" },
{ value: "קדרים", label: "קדרים" },
{ value: "קודייראת א-צאנע שבט", label: "קודייראת א-צאנע שבט" },
{ value: "קוואעין שבט", label: "קוואעין שבט" },
{ value: "קוממיות", label: "קוממיות" },
{ value: "קורנית", label: "קורנית" },
{ value: "קטורה", label: "קטורה" },
{ value: "קיסריה", label: "קיסריה" },
{ value: "קלחים", label: "קלחים" },
{ value: "קליה", label: "קליה" },
{ value: "קלנסווה", label: "קלנסווה" },
{ value: "קלע", label: "קלע" },
{ value: "קציר", label: "קציר" },
{ value: "קצר א-סר", label: "קצר א-סר" },
{ value: "קצרין", label: "קצרין" },
{ value: "קרית אונו", label: "קרית אונו" },
{ value: "קרית ארבע", label: "קרית ארבע" },
{ value: "קרית אתא", label: "קרית אתא" },
{ value: "קרית ביאליק", label: "קרית ביאליק" },
{ value: "קרית גת", label: "קרית גת" },
{ value: "קרית טבעון", label: "קרית טבעון" },
{ value: "קרית ים", label: "קרית ים" },
{ value: "קרית יערים", label: "קרית יערים" },
{ value: "קרית יערים מוסד", label: "קרית יערים מוסד" },
{ value: "קרית מוצקין", label: "קרית מוצקין" },
{ value: "קרית מלאכי", label: "קרית מלאכי" },
{ value: "קרית נטפים", label: "קרית נטפים" },
{ value: "קרית ענבים", label: "קרית ענבים" },
{ value: "קרית עקרון", label: "קרית עקרון" },
{ value: "קרית שלמה", label: "קרית שלמה" },
{ value: "קרית שמונה", label: "קרית שמונה" },
{ value: "קרני שומרון", label: "קרני שומרון" },
{ value: "קשת", label: "קשת" },
{ value: "ראמה", label: "ראמה" },
{ value: "ראס אל-עין", label: "ראס אל-עין" },
{ value: "ראס עלי", label: "ראס עלי" },
{ value: "ראש העין", label: "ראש העין" },
{ value: "ראש פינה", label: "ראש פינה" },
{ value: "ראש צורים", label: "ראש צורים" },
{ value: "ראשון לציון", label: "ראשון לציון" },
{ value: "רבבה", label: "רבבה" },
{ value: "רבדים", label: "רבדים" },
{ value: "רביבים", label: "רביבים" },
{ value: "רביד", label: "רביד" },
{ value: "רגבה", label: "רגבה" },
{ value: "רגבים", label: "רגבים" },
{ value: "רהט", label: "רהט" },
{ value: "רווחה", label: "רווחה" },
{ value: "רוויה", label: "רוויה" },
{ value: "רוח מדבר", label: "רוח מדבר" },
{ value: "רוחמה", label: "רוחמה" },
{ value: "רומאנה", label: "רומאנה" },
{ value: "רומת הייב", label: "רומת הייב" },
{ value: "רועי", label: "רועי" },
{ value: "רותם", label: "רותם" },
{ value: "רחוב", label: "רחוב" },
{ value: "רחובות", label: "רחובות" },
{ value: "רחלים", label: "רחלים" },
{ value: "ריחאניה", label: "ריחאניה" },
{ value: "ריחן", label: "ריחן" },
{ value: "ריינה", label: "ריינה" },
{ value: "רימונים", label: "רימונים" },
{ value: "רינתיה", label: "רינתיה" },
{ value: "רכסים", label: "רכסים" },
{ value: "רם-און", label: "רם-און" },
{ value: "רמות", label: "רמות" },
{ value: "רמות השבים", label: "רמות השבים" },
{ value: "רמות מאיר", label: "רמות מאיר" },
{ value: "רמות מנשה", label: "רמות מנשה" },
{ value: "רמות נפתלי", label: "רמות נפתלי" },
{ value: "רמלה", label: "רמלה" },
{ value: "רמת גן", label: "רמת גן" },
{ value: "רמת דוד", label: "רמת דוד" },
{ value: "רמת הכובש", label: "רמת הכובש" },
{ value: "רמת השופט", label: "רמת השופט" },
{ value: "רמת השרון", label: "רמת השרון" },
{ value: "רמת טראמפ", label: "רמת טראמפ" },
{ value: "רמת יוחנן", label: "רמת יוחנן" },
{ value: "רמת ישי", label: "רמת ישי" },
{ value: "רמת מגשימים", label: "רמת מגשימים" },
{ value: "רמת צבי", label: "רמת צבי" },
{ value: "רמת רזיאל", label: "רמת רזיאל" },
{ value: "רמת רחל", label: "רמת רחל" },
{ value: "רנן", label: "רנן" },
{ value: "רעים", label: "רעים" },
{ value: "רעננה", label: "רעננה" },
{ value: "רקפת", label: "רקפת" },
{ value: "רשפון", label: "רשפון" },
{ value: "רשפים", label: "רשפים" },
{ value: "רתמים", label: "רתמים" },
{ value: "שאר ישוב", label: "שאר ישוב" },
{ value: "שבי דרום", label: "שבי דרום" },
{ value: "שבי ציון", label: "שבי ציון" },
{ value: "שבי שומרון", label: "שבי שומרון" },
{ value: "שבלי - אום אל-גנם", label: "שבלי - אום אל-גנם" },
{ value: "שגב-שלום", label: "שגב-שלום" },
{ value: "שדה אילן", label: "שדה אילן" },
{ value: "שדה אליהו", label: "שדה אליהו" },
{ value: "שדה אליעזר", label: "שדה אליעזר" },
{ value: "שדה בוקר", label: "שדה בוקר" },
{ value: "שדה דוד", label: "שדה דוד" },
{ value: "שדה ורבורג", label: "שדה ורבורג" },
{ value: "שדה יואב", label: "שדה יואב" },
{ value: "שדה יעקב", label: "שדה יעקב" },
{ value: "שדה יצחק", label: "שדה יצחק" },
{ value: "שדה משה", label: "שדה משה" },
{ value: "שדה נחום", label: "שדה נחום" },
{ value: "שדה נחמיה", label: "שדה נחמיה" },
{ value: "שדה ניצן", label: "שדה ניצן" },
{ value: "שדה עוזיהו", label: "שדה עוזיהו" },
{ value: "שדה צבי", label: "שדה צבי" },
{ value: "שדות ים", label: "שדות ים" },
{ value: "שדות מיכה", label: "שדות מיכה" },
{ value: "שדי אברהם", label: "שדי אברהם" },
{ value: "שדי חמד", label: "שדי חמד" },
{ value: "שדי תרומות", label: "שדי תרומות" },
{ value: "שדמה", label: "שדמה" },
{ value: "שדמות דבורה", label: "שדמות דבורה" },
{ value: "שדמות מחולה", label: "שדמות מחולה" },
{ value: "שדרות", label: "שדרות" },
{ value: "שואבה", label: "שואבה" },
{ value: "שובה", label: "שובה" },
{ value: "שובל", label: "שובל" },
{ value: "שוהם", label: "שוהם" },
{ value: "שומרה", label: "שומרה" },
{ value: "שומריה", label: "שומריה" },
{ value: "שוקדה", label: "שוקדה" },
{ value: "שורש", label: "שורש" },
{ value: "שורשים", label: "שורשים" },
{ value: "שושנת העמקים", label: "שושנת העמקים" },
{ value: "שזור", label: "שזור" },
{ value: "שחר", label: "שחר" },
{ value: "שחרות", label: "שחרות" },
{ value: "שחרית", label: "שחרית" },
{ value: "שיבולים", label: "שיבולים" },
{ value: "שיזף", label: "שיזף" },
{ value: "שיטים", label: "שיטים" },
{ value: "שייח' דנון", label: "שייח' דנון" },
{ value: "שילה", label: "שילה" },
{ value: "שילת", label: "שילת" },
{ value: "שכניה", label: "שכניה" },
{ value: "שלווה", label: "שלווה" },
{ value: "שלווה במדבר", label: "שלווה במדבר" },
{ value: "שלוחות", label: "שלוחות" },
{ value: "שלומי", label: "שלומי" },
{ value: "שלומית", label: "שלומית" },
{ value: "שמיר", label: "שמיר" },
{ value: "שמע�", label: "שמע�" },
{ value: "שמרת", label: "שמרת" },
{ value: "שמשית", label: "שמשית" },
{ value: "שני", label: "שני" },
{ value: "שניר", label: "שניר" },
{ value: "שעב", label: "שעב" },
{ value: "שעל", label: "שעל" },
{ value: "שעלבים", label: "שעלבים" },
{ value: "שער אפרים", label: "שער אפרים" },
{ value: "שער הגולן", label: "שער הגולן" },
{ value: "שער העמקים", label: "שער העמקים" },
{ value: "שער מנשה", label: "שער מנשה" },
{ value: "שער שומרון", label: "שער שומרון" },
{ value: "שפיים", label: "שפיים" },
{ value: "שפיר", label: "שפיר" },
{ value: "שפר", label: "שפר" },
{ value: "שפרעם", label: "שפרעם" },
{ value: "שקד", label: "שקד" },
{ value: "שקף", label: "שקף" },
{ value: "שרונה", label: "שרונה" },
{ value: "שריגים לי-און", label: "שריגים לי-און" },
{ value: "שריד", label: "שריד" },
{ value: "שרשרת", label: "שרשרת" },
{ value: "שתולה", label: "שתולה" },
{ value: "שתולים", label: "שתולים" },
{ value: "תאשור", label: "תאשור" },
{ value: "תדהר", label: "תדהר" },
{ value: "תובל", label: "תובל" },
{ value: "תומר", label: "תומר" },
{ value: "תושיה", label: "תושיה" },
{ value: "תימורים", label: "תימורים" },
{ value: "תירוש", label: "תירוש" },
{ value: "תל אביב", label: "תל אביב" },
{ value: "תל אביב - יפו", label: "תל אביב - יפו" },
{ value: "תל יוסף", label: "תל יוסף" },
{ value: "תל יצחק", label: "תל יצחק" },
{ value: "תל מונד", label: "תל מונד" },
{ value: "תל עדשים", label: "תל עדשים" },
{ value: "תל ציון", label: "תל ציון" },
{ value: "תל קציר", label: "תל קציר" },
{ value: "תל שבע", label: "תל שבע" },
{ value: "תל תאומים", label: "תל תאומים" },
{ value: "תלם", label: "תלם" },
{ value: "תלמי אליהו", label: "תלמי אליהו" },
{ value: "תלמי אלעזר", label: "תלמי אלעזר" },
{ value: "תלמי ביל\"ו", label: "תלמי ביל\"ו" },
{ value: "תלמי יוסף", label: "תלמי יוסף" },
{ value: "תלמי יחיאל", label: "תלמי יחיאל" },
{ value: "תלמי יפה", label: "תלמי יפה" },
{ value: "תלמים", label: "תלמים" },
{ value: "תמרת", label: "תמרת" },
{ value: "תנובות", label: "תנובות" },
{ value: "תעוז", label: "תעוז" },
{ value: "תפרח", label: "תפרח" },
{ value: "תקומה", label: "תקומה" },
{ value: "תקוע", label: "תקוע" },
{ value: "תראבין א-צאנע ישוב", label: "תראבין א-צאנע ישוב" },
{ value: "תראבין א-צאנע שבט", label: "תראבין א-צאנע שבט" },
{ value: "תרום", label: "תרום" }]
